<template>
  <div>
    <h1 class="title is-6 has-text-centered has-text-weight-bold">{{ title }}</h1>
    <div class="chart" ref="chart"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { currency, wholeNumber, dateShort } from '@/filters'

google.charts.load('current', {'packages':['corechart']})

export default {
  props: {
    title: {
      required: true
    },
    column: {
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'orderItemsPlaced',
    ]),
    chartAnnotations() {
      return [...new Set(this.orderItemsPlaced.map((item) => item[this.column]).filter(n => n))].sort((a, b) => parseFloat(a.replace('CC', '')) - parseFloat(b.replace('CC', '')))
    },
    chartData() {
      let data = []
      this.chartAnnotations.forEach((annotation) => {
        data.push(this.orderItemsPlaced.filter((item) => item[this.column] === annotation).reduce((carry, item) => carry += item.quantity, 0))
      })
      console.log(data)
      return data
    },
  },
  methods: {
    drawChart () {
      const options = {
        backgroundColor: '#ffffff',
        colors: [ // abbreviated and modified google palette 
          '#3366cc',
          '#dc3912',
          '#ff9900',
          '#109618',
          '#990099',
          '#0099c6',
          '#dd4477',
          '#66aa00',
          '#b82e2e',
          '#316395',
          // '#994499',
          '#22aa99',
          '#aaaa11',
          '#6633cc',
          '#e67300',
          '#8b0707',
          // '#651067',
          // '#329262',
          // '#5574a6',
          // '#3b3eac',
          // '#b77322',
          // '#16d620',
          // '#b91383',
          // '#f4359e',
          // '#9c5935',
          // '#a9c413',
          // '#2a778d',
          // '#668d1c',
          // '#bea413',
          // '#0c5922',
          // '#743411'
        ],
        // colors: [ // default google palette (https://stackoverflow.com/a/75264589)
        //   '#3366cc', 
        //   '#dc3912', 
        //   '#ff9900', 
        //   '#109618',
        //   '#990099', 
        //   '#0099c6', 
        //   '#dd4477', 
        //   '#66aa00',
        //   '#b82e2e', 
        //   '#316395', 
        //   '#994499', 
        //   '#22aa99',
        //   '#aaaa11', 
        //   '#6633cc', 
        //   '#e67300', 
        //   '#8b0707',
        //   '#651067', 
        //   '#329262', 
        //   '#5574a6', 
        //   '#3b3eac',
        //   '#b77322', 
        //   '#16d620', 
        //   '#b91383', 
        //   '#f4359e',
        //   '#9c5935', 
        //   '#a9c413', 
        //   '#2a778d', 
        //   '#668d1c',
        //   '#bea413', 
        //   '#0c5922', 
        //   '#743411'
        // ],
        // colors: [ // blue palette
        //   '#01579B',
        //   '#0277BD',
        //   '#0288D1',
        //   '#039BE5',
        //   '#03A9F4',
        //   '#29B6F6',
        //   '#4FC3F7',
        //   '#81D4FA',
        //   '#B3E5FC',
        //   '#E1F5FE',
        // ],
        title: '',
        fontName: 'Nunito',
        legend: {
          position: 'bottom',
          textStyle: {
            fontName: 'Nunito'
          }
        },
        bar: { groupWidth: '95%' },
        height: 225
      }

      const dataTable = google.visualization.arrayToDataTable([
        ['Timeframe', ...this.chartAnnotations, { role: 'annotation' }],
        ['', ...this.chartData, ''],
      ])

      // let view = new google.visualization.DataView(dataTable);
      // view.setColumns([0, 1,
      //   {
      //     calc: 'stringify',
      //     sourceColumn: 1,
      //     type: 'string',
      //     role: 'annotation'
      //   },
      // 2])

      const chart = new google.visualization.ColumnChart(this.$refs.chart)
      // chart.draw(view, options)
      chart.draw(dataTable, options)
    }
  },
  filters: {
    currency,
    wholeNumber,
    dateShort
  },
  mounted () {
    console.log(this.chartAnnotations)
    google.charts.setOnLoadCallback(() => this.drawChart())    
  }
}
</script>
